import type { Metric } from '@gonfalon/metrics/types';

/**
 * Given a list of metrics, returns the intersection of their randomization units.
 * If the list is empty, returns an empty array.
 */
export function getCommonRandomizationUnits(metrics: Metric[]): string[] {
  if (metrics.length === 0) {
    return [];
  }

  const randomizationUnitsPerMetric = metrics.map((metric) => metric.analysisUnits || []);

  return randomizationUnitsPerMetric.reduce((acc, metricRandomizationUnits) => {
    const set = new Set(metricRandomizationUnits);
    return acc.filter((randomizationUnit) => set.has(randomizationUnit));
  }, randomizationUnitsPerMetric[0]);
}
